import MonthStatus from "../../../VAMP/components/MonitoringProgram/MonthStatus/MonthStatus"

import "./MonthStatusTrigger.less"


const MonthStatusTrigger = ({ icon, variant }) => (
  <span className="month-status-trigger">
    <MonthStatus icon={icon} variant={variant} />
  </span>
)

export default MonthStatusTrigger
